module.exports = __webpack_public_path__ + "f5642fdfa67eb3281caa1368ef0b2c34.pdf";